import React, { FC, useState, useEffect, useRef, KeyboardEvent } from 'react';
import IPresentationPageProps from 'interfaces/IPresentationPageProps';
import styled from 'styled-components';
import { inject, observer } from 'mobx-react';
import colors from 'const/style/colors';
import { DateTime } from 'luxon';
import PresentationModel from 'models/Presentation';
import Popover from 'components/Popover';
import IInstruction from 'interfaces/IInstruction';
import fonts from 'const/style/fonts';
import iconClose from 'assets/icon/ic_highlight_off_24px.svg';
import iconClosePress from 'assets/icon/ic_highlight_off_24px_press.svg';
import iconArrowBack from 'assets/icon/ic_arrow_back_24px.svg';
import iconArrowForward from 'assets/icon/ic_arrow_forward_24px.svg';
import iconClock from 'assets/icon/ic_access_alarms_24px.svg';
import iconClockRed from 'assets/icon/ic_access_alarms_24px_red.svg';
import iconRecord from 'assets/icon/ic_record.svg';
import iconChangePdf from 'assets/icon/ic_change_pdf_24px.svg';
import PresentationStatuses from 'const/PresentationStatuses';
import PresentationReadyCounter from 'components/Presentation/PresentationReadyCounter';
import PresentationEnd from 'components/Presentation/PresentationEnd';
import Modal from 'components/Modal';
import Spinner from 'components/Spinner';
import Video from 'components/Video';
import { useHistory } from 'react-router-dom';
import Login from 'models/Login';
import UserStatusType from 'consts/UserStatusType';
import ProgressBar from "../components/ProgressBar";

const Frame = styled.div`
  width:100%;
  height:100%;
  /* display: grid;
  grid-template-rows: auto auto;
  grid-template-columns: 20em auto; */
  display:flex;
  flex-grow:row;
  justify-content:flex-start;
  align-items:stretch;

  //** layout */
  .frame-left {
    background:${colors.CECECEC};
    position:relative;
    width:175px;
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:stretch;
  }
  .frame-content {
    position:relative;
    flex:1;
    display:flex;
    background:${colors.CECECEC};
    flex-direction:column;
    justify-content:flex-start;
    align-items:stretch;
    padding-left:24px;
    padding-right:24px;
    padding-bottom:30px;
    padding-top:23px;
  }
  
  .frame-thumbs {
    flex:1;
    background:${colors.CF7F7F7};
    flex-direction:column;
    justify-content:flex-start;
    align-tiems:center;
    padding-right:8px;
    padding-top:14px;
    padding-bottom:13px;
    overflow-y:hidden;
    & ::-webkit-scrollbar {
      width: 8px;
    }
    & ::-webkit-scrollbar-thumb {
      background: ${colors.C474747};
    }
    & ::-webkit-scrollbar-track {
      background: ${colors.CECECEC};
    }
    &:hover ::-webkit-scrollbar {
      width: 1em;
    }
    /* border-left:none; */
    /* border-bottom:none; */
    .ol-thumbs {
      overflow-y:auto;
      height:100%;
      counter-reset: slide;
      li {
        position:relative;
        padding-left:24px;
        margin-bottom:1rem;
        cursor:pointer;
        &:before {
          ${fonts.presentation_thumb_number};
          position:absolute;
          top:0;
          left:0;
          margin-left:6px;
          min-width:12px;
          overflow-x:visible;
          text-align:center;
          counter-increment:slide;
          content:counter(slide);
        }
        img{
          width:100%;
          height:100%;
          object-fit:scale-down;
        }
      }
      .slide-thumb {
        width:126px;
        min-height: 69px;
        border: 1px solid ${colors.CCCCCCC};
        display:flex;
        justify-content:center;
        align-items:center;
        &.selected {
          border: 3px solid ${colors.C000000};
        }
      }
    }
    over-flow-y:auto;
  }
  
  .frame-presentation-control  {
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    align-items:center;
    padding-top:32px;
    .frame-seek-control {
      flex:1;
      display:flex;
      justify-content:center;
      align-items:center;
      .seek-control {
        display:flex;
        flex-direction:row;
        justify-content:center;
        align-items:stretch;
        background:${colors.CFFFFFF};
        width:auto;
        min-width:253px;
        height:40px;
        border:1px solid ${colors.C474747};
        border-radius:5px;
        li:not(:last-child) {
          position:relative;
          border-right: 1px solid ${colors.CCCCCCC};
          height:37px;
        }
        .btn-seek-control {
          background:transparent;
          width:46px;
          height:100%;
          border:none;
          text-align:center;
          &.back {
            background:url(${iconArrowBack});
            background-size: 20px 20px;
            background-position:center;
            background-repeat:no-repeat;
            border-radius: 4px 0px 0px 4px;
          }
          &.forward {
            background:url(${iconArrowForward});
            background-size: 20px 20px;
            background-position:center;
            background-repeat:no-repeat;
            border-radius: 0px 4px 4px 0px;
          }
          &:hover, &:active {
            background-color:${colors.CECECEC};
          }
        }
        .li-slide-counter {
          flex:1;
          display:flex;
          justify-content:center;
          align-items:center;
          .seek-counter1 {
            ${fonts.H2_Bold};
          }
          .seek-counter2 {
            ${fonts.H2_Regular};
          }
        }
      }
    }
    .btn-change-pdf {
      ${fonts.H2_Bold};
      width:180px;
      height:40px;
      border-radius: 5px;
      background: ${colors.CFFFFFF};
      border: 1px solid ${colors.C474747};
      margin-right: 10px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items:center;
      .btn-icon {
        margin-right: 13px;
      }
    }
    button.btn-record{
      ${fonts.H2_White};
      border-radius: 5px;
      border:0;
      height:40px;
      width:200px;
      display:flex;
      flex-direction:row;
      justify-content:center;
      align-items:center;      
      .btn-icon {
        width:21px;
        height:21px;
        margin-right:11px;
      }
      &.start {
        background-color:${colors.CE03E31};
        &:hover, &:active {
          background-color:${colors.CC12C20};
        }
      }
      &.end {
        background-color:${colors.C5759D0};
        &:hover, &:active {
          background-color:${colors.C3335AD};
        }
      }
    }
  }
  .frame-presentation {
    flex:1;
    position:relative;
    background:${colors.CECECEC};
    /* border-right:none; */
    /* border-bottom:none; */
    .btn-move-slide {
      position:absolute;
      top:50%;
      &.btn-left {
        left:0;
      }
      &.btn-right {
        right:0;
      }
    }
  }
  .frame-time-count {
    ${fonts.H1_Regular};
    margin-bottom: 2px;
    .time-count {
      margin-left: 5px;
      ${fonts.H1_Bold};
    }
    i.clock {
      display:inline-block;
      width:22px;
      height:22px;
      margin-right:8px;
      margin-bottom:-2px;
      background:url(${iconClock});
      transition: background 0.5s linear;
      &:before {
        display:none;
        content:url(${iconClockRed});
      }
      &.ringing {
        content:url(${iconClockRed});
        animation: ringing .5s infinite;
      }
    }
  }
  .frame-video-preview {
    position:relative;
    width: 100%;
    min-height: 131px;
    .video-preview {
      width:100%;
    }
    .video-status {
      ${fonts.H2_White};
      display:flex;
      justify-content:center;
      align-items:center;
      width:100%;
      height:34px;
      background: ${colors.C2CBFA3CC};
      position:absolute;
      bottom:0;
      left:0;
      &.PRESENTATION {
        background: ${colors.CE03E31CC}
      }
    }
  }

  //** popover */
  .popover-frame-step {
    .popover-frame-step-title1 {
      ${fonts.H3_Green};
    }
    .popover-frame-step-title2 {
      ${fonts.H3_DimGreen};
    }
  }
  .popover-frame-content {
    width:100%;
    height:100%;
    white-space:pre;
    text-align:left;
  }
  .btn-close {
    background:url(${iconClose});
    width:28px;
    height:28px;
    top:8px;
    right:8px;
    position:absolute;
    &:before {
      content: url(${iconClosePress});
      display:none;
    }
    &:hover, &:active {
      background:url(${iconClosePress});
    }
  }

  @keyframes ringing {
    0% {transform: rotate(-15deg);}
    10% {transform: rotate(15deg);}
    20% {transform: rotate(-18deg);}
    30% {transform: rotate(18deg);}
    40% {transform: rotate(-22deg);}
    50% {transform: rotate(22deg);}
    60% {transform: rotate(-18deg);}
    70% {transform: rotate(18deg);}
    80% {transform: rotate(-12deg);}
    90% {transform: rotate(12deg);}
    100% {transform: rotate(0deg);}
  }
`;

const SlideFrame = styled.div`
  width:100%;
  /* height:100%; */
  /* flex:1; */
  &:focus {
    outline:none;
  }
  display:flex;
  flex-direction:row;
  flex-wrap:nowrap;
  justify-content:flex-start;
  align-items:center;
  height:100%;
  .frame {
    position:relative;
    width:100%;
    height:100%;
    overflow:hidden;
    .container {
      height:100%;
      width:auto;
      white-space:nowrap;
      transition:transform ease .5s;
      transform: ${(props) => `translate(${(props as any)['data-slide'] * -100}%, 0)`};
      .slide {
        width:100%;
        height:100%;
        position:relative;
        /* height:40rem; */
        display:inline-flex;
        justify-content:center;
        align-items:center;
        background-color:${colors.C555555};
        &.recording {
          img {
            border:3px solid ${colors.CE03E31};
          }
        }
        img{
          width:100%;
          height:100%;
          position:absolute;
          object-fit:contain;
        }
      }
    }
  }
`;

export const Presentation: FC<IPresentationPageProps> = ({presentation = new PresentationModel(), loginInfo = new Login()}) => {
  const refVideo = useRef<HTMLVideoElement>(null);
  const refComplete = useRef<HTMLButtonElement>(null);
  const refTimecounter = useRef<HTMLDivElement>(null);
  const refSeekCount = useRef<HTMLButtonElement>(null);
  const refInstruction = [refTimecounter, refSeekCount, refComplete];
  const history = useHistory();
  
  const [instructionTurn, setInstructionTurn] = useState<number>(0);

  
  const instructions:IInstruction[] = [
    {
      msg: `본격적인 온라인 PT 녹화에 앞서 2분간 발표자료를 확인할 수 있습니다.\n2분이 지나면 자동으로 온라인 PT 녹화가 시작됩니다.`,
      anchor: refInstruction[0],
      arrow: 'BOTTOM_LEFT',
    },
    {
      msg: `좌우 화살표 버튼 또는 왼쪽의 발표자료 썸네일을 클릭해서\n 페이지를 전환할 수 있습니다. 녹화가 시작되면 페이지를 전환하며\n 프레젠테이션을 진행하세요.`,
      anchor: refInstruction[1],
      arrow:'BOTTOM_LEFT'
    },
    {
      msg: `발표자료를 모두 확인하셨다면\n 녹화 시작 버튼을 클릭하여 온라인 PT 녹화를 시작하세요.`,
      anchor: refInstruction[2],
      arrow:'BOTTOM_RIGHT'
    }
  ];

  useEffect(() => {
    if(refVideo.current && presentation.stream) {
      refVideo.current.srcObject = presentation.stream;
    }
  }, [presentation.stream]);

  useEffect(()=>{
    const checkStream = async () => {
      try {
        await loginInfo.updateNow();
        await presentation.init();
        await presentation.increasePtCount();
        if(!!loginInfo.userInfo?.limitTime)
          presentation.updateLimitTime(60 * Number(loginInfo.userInfo.limitTime));
        else
          presentation.updateLimitTime();
      } catch(e) {
        console.error(e);
        if (!presentation.initLoadingError) {
          history.replace('/streamError');
        }
      }
    }
    checkStream();
  }, [presentation, history]);
  
  const handleDeviceChange = () => {
    history.replace('/streamError');
  }
  
  useEffect(() => {
    try {
      navigator.mediaDevices.addEventListener('devicechange', handleDeviceChange);
      return () => {
        presentation.releaseTimers();
        navigator.mediaDevices.removeEventListener('devicechange', handleDeviceChange);
      }
    } catch(e) {
      handleDeviceChange();
    }
  }, []);
  
  const addHistory = (idx: number) => {
    if(idx >= 0 && idx < presentation.slides.length) {
      if(presentation.presentationStatus === PresentationStatuses.PRESENTATION && presentation.presentationCount > 0)
        presentation.addHistory(idx);
      presentation.currentSlide = idx;
    }
  }

  const moveSlideWithThumbScroll = (slideIdx:number) => {
    addHistory(slideIdx);
    try {
      const thumbList = document.querySelector<HTMLOListElement>('.ol-thumbs');
      const destThumb = document.querySelector<HTMLLIElement>(`.ol-thumbs li:nth-child(${slideIdx})`);
      if(destThumb && thumbList) {
        thumbList?.scrollTo({
          top: destThumb.offsetTop-destThumb.clientHeight,
          behavior: 'smooth',
        });
      }
    } catch(e) {
    }
  }

  const isRinging = (() => (
    (presentation.presentationStatus === PresentationStatuses.PREPARATION && presentation.preparationCount <= 10) ||
    (presentation.presentationStatus === PresentationStatuses.PRESENTATION && presentation.presentationCount <= 30)
  ))();

  return (
    <Frame>
      <div className='frame-left'>
        <div className='frame-video-preview'>
          <Video
            className='video-preview'
            ref={refVideo}
          />
          <div className={`video-status ${presentation.presentationStatus.key}`}>
            {presentation.presentationStatus.text} 중
          </div>
        </div>
        <div
          className='frame-thumbs'
        >
          <ol className='ol-thumbs'>
            {
              presentation.slides.map((thumb, thumbIdx) => (
                <li
                  key={`slide-thumb-${thumbIdx}`}
                  onClick={()=>addHistory(thumbIdx)}
                >
                  <div className={`slide-thumb ${thumbIdx === presentation.currentSlide && 'selected'}`}>
                    {/* <img src={iconClock} alt={`썸네일 #${thumbIdx+1}`}/> */}
                    <img src={thumb} alt={`썸네일 #${thumbIdx+1}`}/>
                  </div>
                </li>
              ))
            }
          </ol>
        </div>
      </div>
      <div className='frame-content'>
        <div className='frame-presentation'>
          <SlideFrame
            data-slide={presentation.currentSlide}
            tabIndex={0}
            onKeyUp={(e:KeyboardEvent<HTMLElement>)=>{
              switch(e.key) {
                case 'ArrowLeft':
                  moveSlideWithThumbScroll(presentation.currentSlide-1);
                  break;
                case 'ArrowRight':
                  moveSlideWithThumbScroll(presentation.currentSlide+1);
                  break;
              }
            }}
          >
            <div className='frame'>
              <div className='container'>
                {
                  presentation.slides.map((slide, slideIdx) => (
                    <div
                      key={`slide-${slideIdx}`}
                      // data-slide={`${config.host}${URIs.get_file(slide.id)}`}
                      className={`slide slide-1 ${presentation.presentationStatus === PresentationStatuses.PRESENTATION && presentation.currentSlide === slideIdx && 'recording'}`}>
                        {/* 슬라이드 */}
                      {/* <img src={iconClock} alt={`슬라이드 #${slideIdx+1}`}/> */}
                      <img src={slide} alt={`슬라이드 #${slideIdx+1}`}/>
                    </div>
                  ))
                }
              </div>
            </div>
          </SlideFrame>
          {/* <button className='btn-move-slide btn-left'
            onClick={()=>addHistory(slideIdx-1)}
          >
            {`<-`}
          </button>
          <button className='btn-move-slide btn-right'
            onClick={()=>addHistory(slideIdx+1)}
          >
            {`->`}
          </button> */}
        </div>
        <div className='frame-presentation-control'>
          <div
            className='frame-time-count'
          >
            <i className={`clock ${ isRinging && 'ringing'}`}/>
            <span
              className='counter-name'
              ref={refTimecounter}
            >
              {presentation.presentationStatus.text} 남은 시간
            </span>
            <span className='time-count'>
            {DateTime.fromSeconds(
              presentation.presentationStatus === PresentationStatuses.PREPARATION ?
              presentation.preparationCount > 0 ? 
              presentation.preparationCount :
              presentation.presentationReadyCount :
              presentation.presentationCount
            ).toFormat('mm:ss')}
            </span>
          </div>
          <div className='frame-seek-control'>
            <ul className='ul-tool seek-control'>
              <li>
                <button
                  ref={refSeekCount}
                  className='btn-seek-control back'
                  title='이전'
                  onClick={()=>moveSlideWithThumbScroll(presentation.currentSlide-1)}
                  >
                </button>
              </li>
              <li className='li-slide-counter'>
                <span className='seek-counter1'>
                  {presentation.currentSlide+1}
                </span>
                <span className='seek-counter2'>
                  &nbsp;/&nbsp;{presentation.slides.length}
                </span>
              </li>
              <li>
                <button
                  className='btn-seek-control forward'
                  title='다음'
                  onClick={()=>moveSlideWithThumbScroll(presentation.currentSlide+1)}
                >
                </button>
              </li>
            </ul>
          </div>
          {
            (loginInfo.ptCount < 2 && presentation.presentationStatus !== PresentationStatuses.PRESENTATION) &&
            <button
              className='btn-change-pdf'
              onClick={() => {presentation.changePdfModalVisible = true;}}
            >
              <img className='btn-icon' src={iconChangePdf} alt='' /> PDF 파일 변경
            </button>
          }
          {
            presentation.presentationStatus === PresentationStatuses.PRESENTATION ?
            <button
              className='btn-record end'
              ref={refComplete}
              onClick={()=>{presentation.uploadModalVisible = true;}}
            >
             온라인 PT 완료 및 제출
            </button>
            :
            <button
              className='btn-record start'
              ref={refComplete}
              onClick={()=>presentation.stopPreparationCount()}
            >
              <img className='btn-icon' src={iconRecord} alt='o'/> 녹화 시작
            </button>
          }
        </div>
      </div>
      {
        instructionTurn < instructions.length &&
        instructions.map((instruction, instructionIdx)=>{ //TODO: 생각해보니 굳이 다 띄울 필요 없을 거 같은데 나중에 찾아볼것
          return (
            <Popover
              key={`indstruction-${instructionIdx}`}
              anchor={instruction.anchor}
              arrow={instruction.arrow}
              open={instructionIdx === instructionTurn}
            >
              <div className='popover-frame-content'>
                <div className='popover-frame-step'>
                  <span className='popover-frame-step-title1'>
                    GUIDE {`${instructionIdx+1}`.padStart(2,'0')}
                  </span>
                  <span className='popover-frame-step-title2'>
                    /{`${instructions.length}`.padStart(2,'0')}
                  </span>
                </div>
                {instruction.msg}
              </div>
              <button
                className='btn-close'
                onClick={()=>{
                  if(instructionIdx === instructions.length -1) {
                    presentation.preparationModalVisible = true;
                  }
                  setInstructionTurn(instructionIdx+1)
                }}
              >
              </button>
            </Popover>
          )
        })
      }
      {
        presentation.presentationStatus === PresentationStatuses.PREPARATION && presentation.preparationCount === 0 && !presentation.presentationModalVisible && presentation.presentationReadyCount >= 0 &&
        <PresentationReadyCounter/>
      }
      {
        presentation.presentationEnd &&
        <PresentationEnd/>
      }
      {
        presentation.loading &&
        <ProgressBar leftText={"PDF 업로드"}
                     rightText={`${presentation?.loadingPage}/${presentation?.totalPage}`}
                     percentage={Math.floor((presentation?.loadingPage / presentation?.totalPage) * 100)}/>
      }
      {
        presentation.initLoadingError &&
        <Modal
          open={presentation.initLoadingError}
        >
          <p>
            접속 중 오류가 발생했습니다.
          </p>
          <p>
            계속 실패한다면 브라우저 새로고침 후 처음부터 다시 진행하세요.
          </p>
          <button className='btn-cta' onClick={()=>presentation.init()}>
            재시도
          </button>
        </Modal>
      }
      <Modal className='modal-preparation' open={presentation.preparationModalVisible}>
        <p>
          {`확인 버튼을 누르면\n최종 자료 확인 시간 2분이 주어집니다.\n준비를 완료한 후 확인 버튼을 눌러주세요.`}
        </p>
        <button className='btn-cta' onClick={()=>{
          presentation.preparationModalVisible = false;
          presentation.startPreparationCount();
        }}>
          확인
        </button>
      </Modal>
      <Modal className='modal-presentation' open={presentation.presentationModalVisible}>
        <p>
          {`5초 카운트다운 후 면접이 시작됩니다.\n 면접을 시작하고 네트워크 문제 등 비정상적인 \n종료의 경우 제한된 횟수 내에서 재응시가 가능하오니 \n긴장하지 마시고 편안하게 응시하시기 바랍니다. \n준비를 완료한 후 확인 버튼을 눌러주세요.`}
        </p>
        <button className='btn-cta' onClick={()=>{
          presentation.presentationModalVisible = false;
          presentation.startPresentationReadyCount();
        }}>
          확인
        </button>
      </Modal>
      <Modal className='modal-presentation-upload' open={presentation.presentationCount > 0 && presentation.uploadModalVisible}>
        <p>
          {`프레젠테이션 녹화를 종료하고\n영상을 제출하시겠습니까?`}
        </p>
        <button className="btn-cta2" onClick={()=>presentation.stopPresentationCount()}>확인</button>
        <button className="btn-cta" onClick={() => {presentation.uploadModalVisible = false;}}>취소</button>
      </Modal>
      <Modal className='modal-change-pdf' open={presentation.changePdfModalVisible && presentation.presentationStatus === PresentationStatuses.PREPARATION}>
        {
          loginInfo.ptCount === 1 ?
          <p>
            {`이미 등록한 발표자료를 삭제하고,\n발표자료 업로드 화면으로 이동합니다.\n단, 이후에는 발표자료를 수정할 수 없으니 신중하게 업로드하세요.`}
          </p>
          :
          <p>
            {`이미 등록한 발표자료를 삭제하고,\n발표자료 업로드 화면으로 이동합니다.`}
          </p>
        }
        <button className="btn-cta2" onClick={async ()=>{
          await loginInfo.updateNow();
          if(!loginInfo.ptCountCheck)
            return;
          else
            history.replace('/upload');
        }}>발표자료 변경</button>
        <button className="btn-cta" onClick={() => {presentation.changePdfModalVisible = false;}}>취소</button>
      </Modal>
    </Frame>
  )
}

export default inject('presentation', 'loginInfo')(observer(Presentation));